import axios from "axios";

const TOKEN_KEY = "bgx_customer_token";

export const customerApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
customerApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const setCustomerToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
export const hasCustomerToken = () => !!localStorage.getItem(TOKEN_KEY);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const gbp = (v, dp = 0) =>
  v == null ? "-" : `${Number(v) < 0 ? "-" : ""}£${Math.abs(Number(v)).toLocaleString("en-GB", { maximumFractionDigits: dp, minimumFractionDigits: dp })}`;
export const pct = (v, dp = 1) => (v == null ? "-" : `${Number(v).toFixed(dp)}%`);
